
















import Vue from "vue";
import iwAccordion from "@/encoding/components/Accordion.vue";
import iwFloorAreaLivingRoom from "./FloorAreaLivingRoom.vue";
import iwInputCheckbox from "@/encoding/components/buildingBlocks/InputCheckbox.vue";
import { mapActions } from "vuex";

export default Vue.extend({
    components: {
        iwAccordion: iwAccordion,
        iwFloorAreaLivingRoom: iwFloorAreaLivingRoom,
        iwInputCheckbox: iwInputCheckbox,
    },

    data: function() {
        return {
            pathInStoreExists: "property.livingRoom.exists",
            pathInStoreFloorAreaLivingRoom: "property.livingRoom.surface",
        };
    },

    computed: {
        isDisplayed: function(): boolean {
            return ["HOUSE","APARTMENT","OTHER", "HOMES_TO_BUILD"].indexOf(this.getPropertyType()) !== - 1;
        },

        livingRoomArea: function(): number | null {
            return this.$store.getters["FormModule/getValue"](this.pathInStoreFloorAreaLivingRoom);
        },

        floorAreaLivingRoomInput: function(): Vue | null {
            if (!this.isDisplayed) {
                return null;
            }

            return (this.$refs.floorAreaLivingRoom as Vue).$refs.floorAreaLivingRoomInput as Vue;
        },

        hasLivingRoom: {
            get: function(): boolean {
                return this.$store.getters["FormModule/getValue"](this.pathInStoreExists);
            },

            set: function(value: boolean) {
                this.$store.dispatch("FormModule/addValue", {
                    path: this.pathInStoreExists,
                    value: value,
                });

                // Remove area when unchecked.
                if (!value) {
                    this.deleteValuePath(this.pathInStoreFloorAreaLivingRoom);
                }
            },
        },
    },
    created: function() {
        if (this.isDisplayed && this.hasLivingRoom == null) {
            this.hasLivingRoom = false;
        }

        if (!this.isDisplayed) {
            this.deleteValuePath(this.pathInStoreExists);
        }
    },

    methods: {
        ...mapActions({
            deleteValuePath: "FormModule/deleteValuePath",
        }),
    },
});
